import React, { forwardRef } from "react";

import { ForwardRefType, QAProps } from "@multiweb/types/react";
import { ComponentTheme } from "@multiweb/uiShared/ComponentTheme";
import { ButtonBackgroundColor, ButtonProvider, ButtonProviderProps } from "../ButtonProvider";
import { Text, TextColor, TextProps, WhiteSpace } from "../Text";
import { TextButtonSpacing } from "../TextButtonSpacing";
import { ComponentSize } from "../types";

export type TextButtonProps = {
    text?: string;
    size?: ComponentSize;
} & ButtonProviderProps & QAProps & Pick<TextProps, "color" | "fontWeight">;

/** Tlačítko v podobě textu */
export const TextButton: ForwardRefType<HTMLButtonElement, TextButtonProps> = forwardRef<HTMLButtonElement, TextButtonProps> (({
    backgroundColor = ButtonBackgroundColor.transparent,
    disabled = false,
    onClick,
    size = ComponentSize.small,
    text = "",
    theme = ComponentTheme.default,
    title,
    tabIndex,
    isFocused = false,
    qa,
    color = TextColor.default,
    fontWeight,
    shadow,
    outline,
    width,
    textAlign,
    ...restProps
}, forwardRef) => (
    <ButtonProvider
        {...{ onClick, title, tabIndex, theme, size, disabled, color, fontWeight, qa, isFocused, backgroundColor, shadow, outline, width, textAlign, ...restProps }}
        ref={forwardRef}
    >
        <TextButtonSpacing {...{ size }}>
            <Text
                isTextSelectable={false}
                value={text}
                whiteSpace={WhiteSpace.nowrap}
                ellipsis={true}
                {...{ theme, color, fontWeight, disabled }}
            />
        </TextButtonSpacing>
    </ButtonProvider>
));
